module.exports = __webpack_public_path__ + "img/ring_g_i_1_null@2x.1d821982.png";